import { ReactElement } from "react";
import { ReactComponent as Waiting } from "./waiting.svg";
import { useTranslation } from "react-i18next";
import Loader, { LoaderType } from "../../Loader/Loader";

const AuthenticationHoldingScreen = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <div className="text-center">
      <Waiting />
      <h2 className="my-4 fw-lighter text-black">
        {t("authenticationHoldingScreen.heading", "Waiting for authentication")}
      </h2>
      <Loader type={LoaderType.BlockSpinner} />
    </div>
  );
};

export default AuthenticationHoldingScreen;
